import { render, staticRenderFns } from "./couponsSaasDataListCopy.vue?vue&type=template&id=86f32a4e&scoped=true"
import script from "./couponsSaasDataListCopy.vue?vue&type=script&lang=js"
export * from "./couponsSaasDataListCopy.vue?vue&type=script&lang=js"
import style0 from "./couponsSaasDataListCopy.vue?vue&type=style&index=0&id=86f32a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f32a4e",
  null
  
)

export default component.exports